const http = uni.$u.http

let data = [];
data.length
/**
 * 垫付列表
 * @param data
 * @returns {HttpPromise<any>}
 */
export const getTmsFinanceDetailList = (data ={}) => http.get('app/car/getTmsFinanceDetailList',{params: {...data}});